module.exports = __webpack_public_path__ + "static/ms-icon-144x144-fb9eb4509199846ca9eb2a6fb690317d.png";